/**
 * Created by Mikhail Menshenin on 20.08.2024
 */

const VillagePlayers = function () {
    cleverapps.EventEmitter.call(this);

    this.results = [];
    this.raided = [];
    this.raidPlayer = undefined;

    cleverapps.bots.listBots(VillagePlayers.AMOUNT).forEach(this.addPlayer.bind(this));
};

VillagePlayers.prototype = Object.create(cleverapps.EventEmitter.prototype);
VillagePlayers.prototype.constructor = VillagePlayers;

VillagePlayers.prototype.save = function () {
    this.results.forEach((player) => {
        if (player.villageLevel === undefined) {
            player.villageLevel = PseudoRandom.GET().random(0, Village.getMaxLevel());
        }
        if (player.gold === undefined) {
            player.gold = PseudoRandom.GET().random(50, 99) * 1400;
        }
    });
    cleverapps.UI.Avatar.preload(this.results);
    this.trigger("update");
};

VillagePlayers.prototype.getPlayers = function () {
    return this.results;
};

VillagePlayers.prototype.getAttackPlayer = function () {
    if (cleverapps.config.debugMode && this.attackPlayer) {
        return this.attackPlayer;
    }

    return PseudoRandom.GET().choose(this.results.filter((player) => player !== this.raidPlayer));
};

VillagePlayers.prototype.getRaidPlayer = function () {
    if (!this.raidPlayer) {
        this.raidPlayer = PseudoRandom.GET().choose(this.getPlayersToRaid());
    }

    return this.raidPlayer;
};

VillagePlayers.prototype.resetRaidPlayer = function () {
    if (this.raidPlayer) {
        this.raided.push(this.raidPlayer);
    }

    if (!this.getPlayersToRaid().length) {
        this.raided.length = 0;
    }

    this.raidPlayer = undefined;
};

VillagePlayers.prototype.getPlayersToRaid = function () {
    return cleverapps.substract(this.results, this.raided, (player) => player.id);
};

VillagePlayers.prototype.getPlayer = function (playerId) {
    return this.results.find((player) => player.id === playerId);
};

VillagePlayers.prototype.addPlayer = function (player) {
    const playerExist = this.getPlayer(player.id);

    if (playerExist) {
        Object.assign(playerExist, {
            villageLevel: player.villageLevel,
            name: player.name,
            avatar: player.avatar,
            gold: player.gold
        });
    } else {
        this.results.push(player);
    }

    this.save();
};

VillagePlayers.AMOUNT = 5;

cleverapps.whenAllInitialized(() => {
    cleverapps.villagePlayers = new VillagePlayers();
});
